import type { ParsedUrlQuery } from 'node:querystring';

import { getParamValue } from '~/utils/params';

export const HUB_PAGE_QUERY_PARAM = 'page';

const PAGE_NUMBER_PATTERN = /^[1-9]\d*$/;

export const LATEST_JOB_OFFERS_PER_PAGE = 10;

// Elasticsearch reads no further than its first 10,000 results: the pages past them cannot be listed
const MAX_SEARCH_RESULTS = 10_000;
export const MAX_HUB_PAGE = Math.floor(MAX_SEARCH_RESULTS / LATEST_JOB_OFFERS_PER_PAGE);

export type HubPagination = { currentPage: number; pageCount: number };

/** The page of offers a city, job or sector page lists, from `?page=`: anything but a page number is the first page. */
export const getHubPage = (query: ParsedUrlQuery) => {
  const page = getParamValue(query[HUB_PAGE_QUERY_PARAM]);
  return page && PAGE_NUMBER_PATTERN.test(page) ? Number(page) : 1;
};

export const getHubPageHref = (path: string, page: number) =>
  page > 1 ? `${path}?${HUB_PAGE_QUERY_PARAM}=${page}` : path;
